<template>
  <!-- 絞り込み用モーダル -->
  <div class="modal-box">
    <div class="modal payment-search-modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">絞り込み</h5>
          </div>
          <div class="modal-body">
            <div class="payment-status-box">
              <p class="checkbox-title payment-status-title">ステータス</p>
              <div class="checkbox-list payment-status-list">
                <ul>
                  <li v-for="(status, index) in paymentStatusCheckboxList" :key="index">
                    <label>
                      <input type="checkbox" class="checkbox payment-status-checkbox" :ref="'payment-status-checkbox-' + index" v-model="selectedPaymentStatus" :value="status" /><span class="payment-status" :ref="'payment-status-' + index">{{ status.label }}</span>
                    </label>
                  </li>
                </ul>
              </div>
            </div>
            <div class="payment-method-box">
              <p class="checkbox-title payment-method-title">支払い方法</p>
              <div class="checkbox-list payment-method-list">
                <ul>
                  <li v-for="(method, index) in paymentMethodCheckboxList" :key="index">
                    <label>
                      <input type="checkbox" class="checkbox payment-method-checkbox" :ref="'payment-method-checkbox-' + index" v-model="selectedPaymentMethod" :value="method" /><span class="payment-method" :ref="'payment-method-' + index">{{ method.label }}</span>
                    </label>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-submit" @click="getAudiences">絞り込む</button>
            <button type="button" class="btn btn-close" @click="$emit('close-btn-click')">キャンセル</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import consts from '../utils/consts';

export default {
  props: {
    get_audiences_path: { type: String, required: true },
  },
  data() {
    return {
      paymentStatusCheckboxList: [
        { id: 'paid', value: consts.PAY_STATUS.PAID, label: '支払済' },
        { id: 'before_paid', value: consts.PAY_STATUS.BEFORE_PAID, label: '支払待ち' },
        { id: 'refund', value: consts.PAY_STATUS.REFUND, label: '払い戻し' },
      ],
      paymentMethodCheckboxList: [
        { id: 'credit_card', value: consts.PAY_METHOD.CREDIT_CARD, label: 'クレカ' },
        { id: 'cvs', value: consts.PAY_METHOD.CVS, label: 'コンビニ' },
      ],
      selectedPaymentStatus: [],
      selectedPaymentMethod: [],
    };
  },
  computed: {
    payment_status: function () {
      return this.$store.getters['audience/getPaymentStatus'];
    },
    payment_method: function () {
      return this.$store.getters['audience/getPaymentMethods'];
    },
    currentPage: function () {
      return this.$store.getters['audience/getCurrentPage'];
    },
  },
  created() {
    this.selectedPaymentStatus = [...this.payment_status];
    this.selectedPaymentMethod = [...this.payment_method];
  },
  methods: {
    async getAudiences() {
      this.$emit('open-loading');
      // 1ページ目の場合はaudiencesを取得
      // それ以外の場合はcurrentPageを書き換える(書き換え先でaudiencesを取得)
      if (this.currentPage == 1) {
        const isAdmissionPage = false;
        await this.$store.dispatch('audience/getAudiences', { api_path: this.get_audiences_path, t: '', isAdmissionPage }).catch((error) => {
          alert('エラーが発生しました。時間をおいてから改めてお試しください。');
        });
      } else {
        this.$store.commit('audience/setCurrentPage', 1);
      }
      this.$emit('close-loading');
      this.$emit('close-btn-click');
    },
  },
  watch: {
    selectedPaymentStatus: function (newVal) {
      this.$store.commit('audience/setPaymentStatus', newVal);
    },
    payment_status: function (newVal) {
      this.selectedPaymentStatus = newVal;
    },
    selectedPaymentMethod: function (newVal) {
      this.$store.commit('audience/setPaymentMethods', newVal);
    },
    payment_method: function (newVal) {
      this.selectedPaymentMethod = newVal;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'app/assets/stylesheets/foundation/variable/color.scss';

.modal-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $translucent-black;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9998;

  .modal {
    z-index: 998;
  }
}

.modal-content {
  box-shadow: none;
  z-index: 9997;
}

.payment-search-modal {
  display: block;
  display: flex;

  .modal-title {
    color: $shop-navy;
    font-size: 15px;
    font-weight: 600;
  }

  .modal-header {
    border-bottom: none;
    text-align: center;
    padding-top: 30px;
  }

  .modal-dialog {
    max-width: 100%;
    width: 315px;
    height: 338px;
    margin: auto;
  }

  .modal-footer {
    width: 260px;
    border-top: none;
    display: flex;
    flex-direction: column;
    margin: auto;
    padding: 0 15px 30px 15px;

    .btn {
      border-radius: 4px;
      width: 100%;
      font-size: 15px;
    }

    .btn-submit {
      margin-top: 30px;
      background-color: $shop-blue;
      border: 1px solid $shop-blue;
      color: #fff;
    }

    .btn-close {
      border: 1px solid $shop-lightgray;
      color: $shop-gray;
      margin-left: 0;
      margin-top: 10px;
      background-color: #fff;
    }
  }

  .modal-body {
    display: flex;
    padding: 0;
    margin: 0 53px;

    .payment-method-box {
      margin-left: 30px;
    }

    .checkbox-title {
      margin-top: 15px;
      color: $shop-navy;
      font-weight: 200;
    }

    .checkbox-list {
      margin-top: 13px;
    }

    .checkbox-list label {
      margin-top: 10px;
      display: flex;
      align-items: center;
      margin-bottom: 0;
      font-weight: 400;
    }

    .checkbox {
      width: 20px;
      height: 20px;
      background: $shop-disable-gray;
      border: 1px solid $shop-border-gray;
      border-radius: 4px;
      opacity: 1;
      position: relative;
      outline: none;
      margin-right: 10px;

      &:checked::before {
        content: '';
        position: absolute;
        top: 1px;
        left: 2px;
        width: 11px;
        height: 7px;
        border-left: solid 2px #fff;
        border-bottom: solid 2px #fff;
        transform: rotate(-39deg);
        background-color: transparent;
      }

      &::after {
        display: none;
      }

      span {
        width: 45px;
        height: 15px;
        text-align: left;
        color: #000;
      }
    }

    .checkbox:checked {
      background: $shop-blue;
    }
  }
}
</style>
